import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { BaseEntryProductComponent } from '@products/base-entry-product-component';
import { Logger } from '@utils/logger';
import { FundHeaderComponentConfig } from '../fund-header-component.config';
import { FundHeaderDisplayComponent } from '../fund-header-display-component.interface';

const logger = Logger.getLogger('FundHeaderEntryComponent');

@Component({
  selector: 'ft-fund-header-entry',
  templateUrl: './fund-header-entry.component.html',
  styleUrls: ['./fund-header-entry.component.scss'],
})
export class FundHeaderEntryComponent
  extends BaseEntryProductComponent
  implements OnInit, OnDestroy {
  @ViewChild('dynamicCmp', {
    read: ViewContainerRef,
    static: false,
  })
  container;

  componentType: string;
  componentRef: ComponentRef<FundHeaderDisplayComponent>;
  componentConfig: FundHeaderComponentConfig;
  isLoading = true;
  errorMsg: string;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.componentType = this.brConfig?.componentType;
    this.componentConfig = FundHeaderComponentConfig.getConfig(
      this.componentType,
      this.configurationName
    );
    this.changeDetector.detectChanges();

    if (this.componentConfig) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
        this.componentConfig.component
      );
      this.container.clear();
      this.componentRef = this.container.createComponent(componentFactory);
      this.isLoading = false;
      this.errorMsg = null;
      this.componentRef.instance.populate(
        this.componentConfig,
        this.brConfig,
        this.component,
        this.page
      );
      this.changeDetector.detectChanges(); // to remove loading message
    } else {
      logger.error(
        'No component found: ',
        this.componentType,
        this.configurationName
      );
      this.errorMsg = `No component found: ${this.componentType}, ${this.configurationName}`;
    }
  }

  ngOnDestroy() {
    // clean up dynamic component to avoid memory leaks
    this.componentRef?.destroy();
  }
}
